import type React from 'react';
import styles from './MultipleChoiceField.module.css';

type Options = {
  id: number;
  icon: React.ReactNode;
  text: string;
}

interface Props {
  label: string,
  options: Options[],
  onChange: (id: number) => void,
  selectedId?: number | null,
  required: boolean,
  className: string,
}

export default function MultipleChoiceField({
  label, options, onChange, selectedId = -1, required, className,
}: Props) {
  return (
    <div className={className}>
      <p className={styles.input}>
        {(required) && (<span className={styles.required}> * </span>)}
        {label}
      </p>
      <div className={(options.length > 2) ? styles.row : styles.centeredElement}>
        {
          options.map((option) => (
            <div
              role="button"
              tabIndex={0}
              key={option.id}
              className={(selectedId === option.id) ? `${styles.option} ${styles.optionSelected}` : styles.option}
              onClick={() => onChange(option.id)}
              onKeyDown={() => onChange(option.id)}
            >
              {(option.icon) && (
                <span className={styles.icon}>
                  {' '}
                  {option.icon}
                  {' '}
                </span>
              )}
              <p>
                {option.text}
              </p>
            </div>
          ))
        }
      </div>
    </div>
  );
}
